import { ref, onMounted, onUnmounted } from 'vue'
import { detectDeviceType } from '@/lib/utils'

export function useMobileLandscape() {
  const isMobileLandscape = ref(false)

  let mql: MediaQueryList

  const update = () => {
    isMobileLandscape.value = detectDeviceType() === 'mobile' && mql.matches
  }

  onMounted(() => {
    if (typeof window === 'undefined' || detectDeviceType() !== 'mobile') return

    mql = window.matchMedia('(orientation: landscape)')
    update()

    mql.addEventListener?.('change', update) ?? mql.addListener(update)
  })

  onUnmounted(() => {
    if (!mql) return
    mql.removeEventListener?.('change', update) ?? mql.removeListener(update)
  })

  return { isMobileLandscape }
}